<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="autorization-header">
    <div class="autorization-header__description">
      <p
        v-if="homeTexts['description-1']"
        v-html="homeTexts['description-1']"
      />
      <YearSelector v-if="isAnnualPass" />
      <p
        v-if="homeTexts['description-2']"
        v-html="homeTexts['description-2']"
      />
      <p
        v-if="homeTexts['description-3']"
        v-html="homeTexts['description-3']"
      />
      <p
        v-if="homeTexts['description-4']"
        v-html="homeTexts['description-4']"
      />
    </div>
    <Button
      class="p-button-secondary autorization-header__footer"
      label="Ampliar información"
      tabindex="0"
      @click="goToInfo"
      @keyup.enter="goToInfo"
    />
  </div>
</template>

<script setup>
// #region VUE
import {
  ref,
  computed,
} from 'vue';
// #endregion

// #region Components
import Button from 'primevue/button/sfc';
import YearSelector from '@/components/year-selector/YearSelector.vue';

// #endregion

// #region Composables
import {useStore} from 'vuex';
import {useDebounceFn} from '@vueuse/core';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const DEFAULT_INFORMATION_URL = 'https://www.transportes.gob.es/transporte_terrestre/verano-joven';
const DEBOUNCE_DELAY = 200; // milliseconds
const DEBOUNCE_MAX_WAIT = 700; // milliseconds
const urlAmplifyInfo = ref(STTEDRA_URL_AMPLIFY_INFORMATION);
const isAnnualPass = computed(() => store.getters['app/isAnnualPass']);

const store = useStore();
const homeTexts = computed(() => store.getters['text/getSectionTexts']('home'));
// #endregion

// #region Functions
/**
 * Opens the Information URL in a new browser tab.
 *
 * This function is debounced to prevent rapid successive calls.
 */
const goToInfo = useDebounceFn(goToInfoFn, DEBOUNCE_DELAY, {maxWait: DEBOUNCE_MAX_WAIT});

/**
 * Function to open the Information URL in a new tab.
 *
 * @throws Will log an error if the URL fails to open.
 */
function goToInfoFn() {
  try {
    const url = urlAmplifyInfo.value ?? DEFAULT_INFORMATION_URL;
    window.open(url, '_blank');
  } catch (error) {
    useDev.error('[Authorization.js] goToInfoFn', error);
  }
}
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss">
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.autorization-header {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: $brand__boxspace--medium;
  justify-content: flex-end;

  & p {
    margin: 0 0 0.75rem 0 !important;
    font-size: 16px !important;
  }

  &__description {
    width: 100%;
  }

  &__footer {
    background-color: $pv__color--white;
    font-size: 1rem;
    // margin-bottom: 2rem;
    padding: 1rem 2rem;
  }
}
</style>
